package com.exura.features.publicplans.domain.model

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("PublicPlanStatistics")
data class PublicPlanStatistics(
    @JsName("viewCount")
    val viewCount: Int = 0,

    @JsName("accessCount")
    val accessCount: Int = 0,

    @JsName("lastViewDate")
    val lastViewDate: String? = null,

    @JsName("lastAccessedDate")
    val lastAccessedDate: String? = null,
)
